<template>
    <el-dialog title="查看PDF文件" :visible.sync="dialogFormVisible" width="1200px" top="5vh" center :close-on-click-modal="false" @close="closeDialog">
        <div>
          <!-- <pdf style="width: 100%;" ref="pdf" :src="pdfUrl"></pdf> -->
          <iframe :src="pdfUrl" width="100%" height="700px"></iframe>
        </div>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button style="width: 120px;background: #9B9B9B;border: none;" size="small" type="primary" @click="closeDialog">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
  import pdf from 'vue-pdf'
  import axios from 'Axios'

  export default {
    props: ['visible','superDataURL'],
    components: {
     pdf
    },
  	data(){
  		return {
        dialogFormVisible:false,
        pdfUrl:''
  		}
  	},
  	created(){

  	},
  	computed: {

  	},
  	methods:{
      getPdfUrls(row){
        const _=this;
        let baseURL=this.$rootUrl;
        _.pdfUrl = baseURL+'receipt'+row.receiptState
      },
      closeDialog(){
        this.dialogFormVisible=false
        this.$emit('refresh',false)
      },
  	},
  	mounted() {

  	},
    watch: {
      　　visible: {
    　　　　handler(newValue, oldValue) {
              if(newValue.showdialog){
                this.dialogFormVisible=true;
                if(this.superDataURL){
                  this.pdfUrl = this.superDataURL;
                }else {
                  this.getPdfUrls(newValue.row);
                }

              }
    　　　　},
    　　　　deep: true,
           immediate: true
      　　},

        }
  }
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/bankwater/showpdf.vue